import React, { Fragment, useState, useEffect, useRef } from 'react'
import GoogleMapReact from 'google-map-react';
import { Tabs } from '../../../2_Molecules/Tabs/Tabs';
import DealerCard from '../../../2_Molecules/DealerCard/DealerCard';
import Marker from '../../../1_Atoms/Marker/Marker';
import Spinner from '../../../1_Atoms/Spinner/Spinner';
import { languageController } from '../../../../controllers/language/languageController';
import { setItemOnLocalStorage } from '../../../../utils/helpers';
import { localStorageKeys } from '../../../../utils/constants';
import generalController from '../../../../controllers/generalController';
// @ts-ignore - GSAP provides its own types but the module path is not recognized
import { gsap, ScrollToPlugin } from "gsap/all";
import { dealerNavigatorHelper } from '../../../../utils/dealerNavigatorHelper';
import { convertPostalToCoordinates, getCurrentBounds, getDealersInViewport, getPreviousUserlocation, getUserGeoLocation, storeUserLocation } from '../../../../utils/googleMapHelper';

// Register ScrollToPlugin.
gsap.registerPlugin(ScrollToPlugin);

interface DealerGeolocation {
  latitude: number;
  longitude: number;
}

interface DealerData {
  dealer_code: number;
  name: string;
  geolocation: DealerGeolocation;
  schedule_service_link?: string;
}

interface UserLocation {
  lat: number;
  lng: number;
}

interface DealerMapProps {
  dealers: DealerData[];
  searchDealers: (searchValue: string | UserLocation, searchType: string) => Promise<void>;
  setMap: (map: google.maps.Map | null) => void;
  map: google.maps.Map | null;
  setIsMapLoaded: (loaded: boolean) => void;
  isStepRenderType?: boolean;
  isEmbeddedOnBnP?: boolean;
  onSelectDealer?: (data: { dealer: DealerData; userPosition: UserLocation }) => void;
  BaSALink?: string;
  BaTDLink?: string;
  GaQLink?: string;
  currentLang?: string;
  preDefinedDealerId?: string;
  language?: string;
  displayServiceHoursOnly?: boolean;
  setIsModalOpen: (open: boolean) => void;
  setDealerData: (dealer: DealerData | false) => void;
  isModelPreOrder?: boolean;
  searchType: string;
}

declare global {
  interface Window {
    bnp_retailer_mode?: boolean;
  }
}

const DealerMap: React.FC<DealerMapProps> = ({
  dealers,
  searchDealers,
  setMap,
  map,
  setIsMapLoaded,
  isStepRenderType = false,
  isEmbeddedOnBnP = false,
  onSelectDealer,
  BaSALink,
  BaTDLink,
  GaQLink,
  currentLang,
  preDefinedDealerId,
  language,
  displayServiceHoursOnly,
  setIsModalOpen,
  setDealerData,
  isModelPreOrder = false,
  searchType
}) => {
  const [activeTab, setActiveTab] = useState<string>(() => {
    // If it's on mobile or tablet, the default view is map.
    const isSmallDevice = ['xs', 'sm', 'md'].includes(generalController.getMediaQuery() || '');
    //return isSmallDevice ? 'map' : 'list';
    return 'list';
  });
  const [activeDealer, setActiveDealer] = useState<number | ''>('')
  const [selectedDealer, setSelectedDealer] = useState<number | ''>(() => preDefinedDealerId ? Number(preDefinedDealerId) : '')

  const [isMapUpdating, setIsMapUpdating] = useState<boolean>(false)
  const [userCurrentPos, setUserCurrentPos] = useState<UserLocation>({ lat: 43.7713, lng: -79.8165 })

  const [scrollbar, setScrollbar] = useState<Window | HTMLDivElement | null>(null)
  const scrollWrapper = useRef<HTMLDivElement>(null)
  const cardsRef = useRef<(HTMLDivElement | null)[]>([])

  const [latLong, setLatLong] = useState<UserLocation>({ lat: 0, lng: 0 })
  const [zoomLevel, setZoom] = useState<number>(4);

  const [displayedDealers, setDisplayedDealers] = useState<DealerData[]>([]);

  useEffect(() => { 
    setSelectedDealer(preDefinedDealerId ? Number(preDefinedDealerId) : '')
  }, [preDefinedDealerId])

  useEffect(() => { 
    if (displayedDealers.length > 0) {
      let dealerIndex = 0;

      if(selectedDealer !== '')
          dealerIndex = displayedDealers.findIndex(dealer => dealer.dealer_code === selectedDealer);
      
      if(dealerIndex === -1) dealerIndex = 0;
      console.log(dealerIndex)

      setActiveDealer(displayedDealers[dealerIndex].dealer_code);

      if(!window.bnp_retailer_mode){
          setLatLong({ lat: displayedDealers[dealerIndex].geolocation.latitude, lng: displayedDealers[0].geolocation.longitude}); 
          setUserCurrentPos({
            lat: displayedDealers[dealerIndex].geolocation.latitude,
            lng: displayedDealers[dealerIndex].geolocation.longitude
          });
      }

      if(map?.getCenter()?.lat() != undefined && window.bnp_retailer_mode){
        setLatLong({ lat: displayedDealers[dealerIndex].geolocation.latitude, lng: displayedDealers[0].geolocation.longitude}); 
        setUserCurrentPos(latLong);
        console.log('setting retailer coord')
        console.log(map.getCenter()?.lat(), map.getCenter()?.lng())
        console.log(latLong)
      }
      // Init cardsRef array;
      cardsRef.current = [];
      setZoom(10);
    }else{
      if(map?.getCenter()?.lat() != undefined && !window.bnp_retailer_mode){
        setUserCurrentPos({
          lat: map.getCenter()!.lat(),
          lng: map.getCenter()!.lng()
        });

      }
      setZoom(4);
    }
  }, [displayedDealers])
  
  // Set the first dealer (closest/most relavant) as active.
  useEffect(() => {
    if (dealers.length > 0) {
      dealerNavigatorHelper.init(dealers);
      setDisplayedDealers(dealerNavigatorHelper.getNext());
    }else{
      setDisplayedDealers([]);
    }
  }, [dealers])

  useEffect(() => {
    // timeoutId for debounce mechanism
    let timeoutId: NodeJS.Timeout | null = null;

    // Handle different auto-scrolling behaviour on small vs large devices.
    const resizeListener = () => {
      // Prevent execution of previous setTimeout
      if (timeoutId) clearTimeout(timeoutId);
      // Run handleSmoothScroller after 150 milliseconds.
      timeoutId = setTimeout(() => {
        const isSmallDevice = ['xs', 'sm', 'md'].includes(generalController.getMediaQuery() || '');
        const scroller = isSmallDevice ? window : scrollWrapper.current;
        setScrollbar(scroller)

       
      }, 150);
    };

    // Run once when loaded
    resizeListener();
    // Set resize listener
    window.addEventListener('resize', resizeListener);

    return () => {
      // Remove resize listener
      window.removeEventListener('resize', resizeListener);
    }
  }, [])

  // Handle dealers update when map is dragged/zoomed
  const handleMapChange = async (map: google.maps.Map) => {
    if(!window.bnp_retailer_mode){
      if (searchType === 'keyword') return;
      if (!map) return;
      if (zoomLevel === 4) return;

      setIsMapUpdating(true)

      // Get center coordinates of the updated map
      const coordinates: UserLocation = {
        lat: map.getCenter()!.lat(),
        lng: map.getCenter()!.lng()
      }

      // Get new dealers with the new coordinates.
      await searchDealers(coordinates, 'geolocation')

      setIsMapUpdating(false)
    }
  }

  const handleDealerSelect = (dealerData: DealerData) => {
    
    // Set dealer data
    if (onSelectDealer) {
      onSelectDealer({
        dealer: dealerData,
        userPosition: userCurrentPos
      })
    }

    // If the selected dealer is the currently selected one, return.
    if (dealerData.dealer_code === selectedDealer) return;
    
    // Set the dealer as the selected
    setSelectedDealer(dealerData.dealer_code)

    // Handle storing selected dealer data on localstorage.
    setItemOnLocalStorage(localStorageKeys.DEALER_SELECTED_BY_USER, dealerData)
  }

  // Get the offset top when scroll to the selected dealer card on mobile/tablet.
  const getScrollBarOffsetTop = (): number => {
    const isSmallDevice = ['xs', 'sm', 'md'].includes(generalController.getMediaQuery() || '');

    if (isSmallDevice) {
      const stepsNav = document.querySelector('.mz-form-steps-nav.active') as HTMLElement;
      const stepsNavOffset = stepsNav ? stepsNav.offsetHeight : 0;
      const pageTop = document.querySelector('.mz-page-top') as HTMLElement;
      const pageTopOffset = pageTop ? Number(pageTop.style.paddingTop.replace('px', '')) : 0;

      return pageTopOffset + stepsNavOffset;
    }

    return 0;
  }

  const loadMoreDealersOnClick = () => {
    if (displayedDealers.length < dealers.length) {
      setDisplayedDealers(dealerNavigatorHelper.getNext());
    }
  }
  
  useEffect(() => {
    // re-render the component when zoomLevel changes
    console.log('Map zoom level:', zoomLevel);
  }, [zoomLevel])

  return (
    <div className="mz-dealer-map">
      <div className="mz-container">
        <div className="mz-dealer-map__inner grid-inner-content">
          <Tabs
            setVisibleTab={(id) => setActiveTab(id)}
            activeTab={activeTab}
            dataTabs={[
              {
                id: 'list',
                tabTitle: languageController.getCopy('findDealer', 'mobileList') || '',
              },
              {
                id: 'map',
                tabTitle: languageController.getCopy('findDealer', 'mobileMap') || '',
              },
            ]}
          />
          <div className={`mz-dealer-map__wrapper ${activeTab === 'map' ? 'active-map' : ''}`}>
            <Fragment>
              <div
                className="mz-dealer-map__dealers"
                ref={scrollWrapper}
              >
                <div className="mz-dealer-map__dealers--inner">
                  {
                    displayedDealers.length > 0 && (
                      displayedDealers.map((dealer, index) => (
                        <DealerCard
                          cardsRef={cardsRef}
                          key={dealer.dealer_code}
                          dealerData={dealer as any}
                          isLean={isStepRenderType}
                          index={index + 1}
                          isActive={(dealer.dealer_code === activeDealer)}
                          onClick={() => { 
                            if(!window.bnp_retailer_mode){
                              setActiveDealer(dealer.dealer_code);

                              setZoom(10);

                              // Set the first most relavant dealer as center.
                              map?.setCenter({
                                lat: dealer.geolocation.latitude,
                                lng: dealer.geolocation.longitude
                              })

                              gsap.to(scrollbar, {
                                delay: 0.9,
                                duration: .5,
                                scrollTo: { y: cardsRef.current[index], offsetY: getScrollBarOffsetTop() }
                              });
                            }
                          }}
                          userCurrentPos={userCurrentPos}
                          // isSelected={(dealer.dealer_code === selectedDealer)}
                          onSelect={() => handleDealerSelect(dealer)}
                          BaSALink={BaSALink}
                          BaTDLink={BaTDLink}
                          GaQLink={GaQLink}
                          isEmbeddedOnBnP={isEmbeddedOnBnP}
                          currentLang={currentLang}
                          language={language}
                          displayServiceHoursOnly={displayServiceHoursOnly}
                          setIsModalOpen={setIsModalOpen}
                          setDealerData={setDealerData}
                          isModelPreOrder={isModelPreOrder}
                        />
                      ))
                    )
                  }

                  {dealers.length > 0 && dealerNavigatorHelper.hasMoreDealers() && (
                      <button type="button" className="mz-btn mz-btn--red" style={{width: '100%'}} data-menu-name="Select dealer" data-form-name="Find a dealer" data-form-event="Show More" onClick={loadMoreDealersOnClick}>
                        <span>{languageController.getCopy('findDealer', 'loadMore') || ''}</span>
                      </button>
                    )
                  }

                  {
                    displayedDealers.length == 0 &&  (
                      <>
                        <div className="mz-dealer-map__noDealers"><div>{languageController.getCopy('findDealer', 'instructions') || ''}</div></div>
                      </>
                    )
                  }
                </div>
              </div>
              <div className="mz-dealer-map__map-widget">
                <GoogleMapReact
                  bootstrapURLKeys={{
                    key: process.env.REACT_APP_GOOGLE_MAP_KEY || '',
                    region: 'ca',
                    language: typeof document !== 'undefined' && document.documentElement.lang?.toLowerCase().startsWith('fr') ? 'fr' : 'en'
                  }}
                  defaultCenter={latLong}
                  center={latLong}
                  zoom={zoomLevel}
                  options={{
                    minZoom: 4,
                    maxZoom: 17,
                    fullscreenControl: false,
                    scrollwheel: false
                  }}
                  yesIWantToUseGoogleMapApiInternals
                  onDragEnd={() => handleMapChange(map!)}
                  onZoomAnimationEnd={() => handleMapChange(map!)}
                  onGoogleApiLoaded={({ map }) => {
                    // Set Google Map instance
                    setMap(map)
                    // Set isMapLoaded true
                    setIsMapLoaded(true)
                  }}
                >
                  {
                    displayedDealers.map((dealer, index) => (
                      <Marker
                        key={dealer.dealer_code}
                        lat={dealer.geolocation.latitude}
                        lng={dealer.geolocation.longitude}
                        isActive={(dealer.dealer_code === activeDealer)}
                        index={index + 1}
                        ariaLabel={`${index + 1}. ${dealer.name}`}
                        onClick={() => {
                          setActiveDealer(dealer.dealer_code)
                          // Switch to list view (for small devices).
                          setActiveTab('list')
                          // Scroll into the selected dealer card after the collapse anim is done.
                          gsap.to(scrollbar, {
                            delay: 0.9,
                            duration: .5,
                            scrollTo: { y: cardsRef.current[index], offsetY: getScrollBarOffsetTop() }
                          });
                        }}
                      />
                    ))
                  }
                </GoogleMapReact>
                {
                  isMapUpdating && <Spinner />
                }
              </div>
            </Fragment>
          </div>
        </div>
      </div>
    </div >
  )
}

export default DealerMap
